export default "__VITE_PUBLIC_ASSET__0f3da6fa__"